var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTorusLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.922,
    height: 16,
    viewBox: "0 0 14.922 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#e0e0e0;stroke-miterlimit:10;}.b{stroke:#fff;}.c,.d{stroke:none;}.d{fill:#fff;}.e{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-895.442 -468.33)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(0 -2.804)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M 903.63623046875 486.6342163085938 L 899.9144287109375 486.6342163085938 L 899.9144287109375 476.2150573730469 L 899.9144287109375 475.7150573730469 L 899.4144287109375 475.7150573730469 L 895.9417724609375 475.7150573730469 L 895.9417724609375 471.9932556152344 L 899.4144287109375 471.9932556152344 L 903.63623046875 471.9932556152344 L 903.63623046875 476.2150573730469 L 903.63623046875 486.6342163085938 Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M 896.4417724609375 472.4932556152344 L 896.4417724609375 475.2150573730469 L 899.4144287109375 475.2150573730469 L 900.4144287109375 475.2150573730469 L 900.4144287109375 476.2150573730469 L 900.4144287109375 486.1342163085938 L 903.13623046875 486.1342163085938 L 903.13623046875 476.2150573730469 L 903.13623046875 472.4932556152344 L 899.4144287109375 472.4932556152344 L 896.4417724609375 472.4932556152344 M 895.4417724609375 471.4932556152344 L 899.4144287109375 471.4932556152344 L 904.13623046875 471.4932556152344 L 904.13623046875 476.2150573730469 L 904.13623046875 487.1342163085938 L 899.4144287109375 487.1342163085938 L 899.4144287109375 476.2150573730469 L 895.4417724609375 476.2150573730469 L 895.4417724609375 471.4932556152344 Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(904.946 469.086) rotate(-9.217)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "c",
    cx: 2.361,
    cy: 2.361,
    r: 2.361
  }), /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 2.361,
    cy: 2.361,
    r: 1.861
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorusLogo);
export default __webpack_public_path__ + "static/media/torus-logo.4fda65d67f9406075418052c2d984974.svg";
export { ForwardRef as ReactComponent };